import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import KobooButton from '../Layout/KobooButton';
import defaultStyles from '../../constants/stylesDefault';
import * as routes from '../../constants/routes';
import { getRenters } from '../../store/renters/actions';
import { postSite } from '../../store/sites/actions';
import Spinner from '../Layout/Spinner';
import Loader from '../Layout/Loader';
import KobooTextField from '../Layout/KobooTextField.jsx';
import withAuthorization from '../../hoc/withAuthorization';
import SiteSlot from './SiteSlot';
import { handleError } from '../../store/infos/actions';
import SiteBusinessHours from './SiteBusinessHours';
import defaultBusinessHours from '../../constants/defaultBusinessHours';
import SiteTypeSelect from './SiteTypeSelect';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import SiteLongLocationDuration from './SiteLongLocationDuration';
import { getLongLocationTypes } from '../../store/longLocationDurations/actions';

const styles = theme => (
  {
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    listItem: {
      display: 'flex',
    },
    day: {
      width: 100,
    },
    businessHoursSwitch: {
      marginRight: 30,
    },
    timePicker: {
      maxWidth: 150,
      margin: '0px 30px',
    },
    afternoonTime: {
      marginLeft: 40,
      display: 'flex',
    },
  }
);

const byPropKey = (propertyName, value) => () => (
  {
    [propertyName]: value,
  }
);

const INITIAL_STATE = {
  renter_id: '',
  number: '',
  name: '',
  email: '',
  phone: '',
  latitude: '',
  longitude: '',
  radius: '',
  caution: '',
  description: '',
  slots: [
    {
      price: 0,
      time: 0,
      position: 1,
    },
  ],
  type: 0,
  isOpenAllTime: false,
  isBookable: false,
  isFreeBooking: false,
  businessHours: defaultBusinessHours,
  longLocationDurations: [],
};

export class AddSiteForm extends Component {
  state = { ...INITIAL_STATE };

  static propTypes = {
    authUser: PropTypes.object,
    classes: PropTypes.object.isRequired,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = {
        ...newState,
        role,
      };
      if (!props.renters && !props.pending && !props.error) {
        props.getRenters(props.authUser.ma, role);
      }
      if (!props.llts.content && !props.llts.pending && !props.llts.error) {
        props.getLongLocationTypes(props.authUser.ma);
      }
    }
    return newState;
  }

  checkTime = (businessHours) => {
    let businessHoursError = [];
    businessHours.forEach(businessHour => {
      if (
        (
          !businessHour.is_continuous_day &&
          (
            businessHour.morning_start >= businessHour.morning_end ||
            businessHour.morning_end >= businessHour.afternoon_start ||
            businessHour.afternoon_start >= businessHour.afternoon_end
          )
        ) ||
        (
          businessHour.is_continuous_day && businessHour.morning_start >= businessHour.morning_end
        )
      ) {
        businessHoursError.push(
          'Certains horaires commencent avant que ceux d\'avant ne se terminent',
        );
      }
    });
    return businessHoursError;
  };

  onSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const {
      renter_id,
      number,
      name,
      email,
      phone,
      latitude,
      longitude,
      radius,
      caution,
      description,
      slots,
      type,
      isOpenAllTime,
      businessHours,
      isBookable,
      longLocationDurations,
      isFreeBooking,
    } = this.state;
    const isInvalid =
      renter_id === '' ||
      name === '' ||
      latitude === '' ||
      longitude === '' ||
      radius === '' ||
      caution === '';

    if (!isInvalid) {
      let errorBusinessHours = this.checkTime(businessHours);
      let emptySlot = slots.find(slot => slot.time === 0);
      if (errorBusinessHours.length > 0) {
        this.props.handleError({ message: errorBusinessHours[0] });
      } else if (emptySlot) {
        this.props.handleError({ message: 'Tous les créneaux doivent avoir une durée.' });
      } else {
        slots.forEach((slot) => {
          slot.price = slot.price * 100;
        });
        this.props.postSite(this.props.authUser.ma, renter_id, {
          number: number || null,
          name,
          email,
          phone,
          latitude,
          longitude,
          radius,
          caution: caution * 100,
          description,
          slots,
          type,
          is_open_all_time: isOpenAllTime,
          business_hours: businessHours,
          is_bookable: isBookable,
          is_free_booking: isFreeBooking,
          long_location_durations: longLocationDurations.map(elem => {
              // caution you pass price for one month
              return {
                ...elem,
                mechanical_price: elem.mechanical_price !== ''
                  ? elem.mechanical_price
                  : null,
                electric_price: elem.electric_price !== ''
                  ? elem.electric_price
                  : null,
              };
            },
          ),
        })
          .then(value => {
            if (value) {
              this.props.history.push(routes.SITES);
            }
          });
      }
    }
  };

  handleChangeType = event => {
    this.setState({ type: event.target.value });
    if (event.target.value === 5) {
      this.setState({ isBookable: true, isFreeBooking: false });
    }
  };

  handleChangeIsBookable = () => {
    this.setState({ isBookable: !this.state.isBookable });
  };
  handleChangeIsFreeBooking = () => {
    this.setState({ isFreeBooking: !this.state.isFreeBooking });
  };
  handleAddSlot = () => {
    let slot = {
      price: 0,
      time: 0,
      position: this.state.slots.length + 1,
    };
    this.state.slots.push(slot);
    this.setState({ slots: this.state.slots });
  };

  handleRemoveSlot = () => {
    this.state.slots.pop();
    this.setState({ slots: this.state.slots });
  };

  onChangeSlotPrice = (price, index) => {
    this.setState(({ slots }) => (
      {
        slots: [
          ...slots.slice(0, index),
          {
            ...slots[index],
            price: parseFloat(price),
          },
          ...slots.slice(index + 1),
        ],
      }
    ));
  };

  onChangeSlotTime = (time, index) => {
    this.setState(({ slots }) => (
      {
        slots: [
          ...slots.slice(0, index),
          {
            ...slots[index],
            time: parseInt(time, 10),
          },
          ...slots.slice(index + 1),
        ],
      }
    ));
  };

  handleSwitchIsOpenAllTime = event => {
    this.setState({ isOpenAllTime: event.target.checked });
  };

  handleSwitch = (event, businessHour, name) => {
    event.persist();
    const businessHourIndex = this.state.businessHours.findIndex(b => b.day === businessHour.day);
    this.setState(({ businessHours }) => (
      {
        businessHours: [
          ...businessHours.slice(0, businessHourIndex),
          {
            ...businessHours[businessHourIndex],
            [name]: event.target.checked,
          },
          ...businessHours.slice(businessHourIndex + 1),
        ],
      }
    ));
  };

  handleChangeTime = (event, businessHour, name) => {
    event.persist();
    const businessHourIndex = this.state.businessHours.findIndex(b => b.day === businessHour.day);
    this.setState(({ businessHours }) => (
      {
        businessHours: [
          ...businessHours.slice(0, businessHourIndex),
          {
            ...businessHours[businessHourIndex],
            [name]: event.target.value,
          },
          ...businessHours.slice(businessHourIndex + 1),
        ],
      }
    ));
  };

  handleAddLongLocationDuration = () => {
    if (this.props.llts.content.length > 0) {
      const firstLlt = this.props.llts.content[0];
      let currentLlds = [...this.state.longLocationDurations];
      const newLld = {
        'is_enabled': true,
        'is_mechanical_available': false,
        'mechanical_price': '',
        'is_electric_available': false,
        'electric_price': '',
        'long_location_type': { ...firstLlt },
      };
      currentLlds.push(newLld);
      this.setState({ longLocationDurations: currentLlds });
    }
  };

  handleEditLongLocationDuration = (lld, property) => {
    let currentLlds = [...this.state.longLocationDurations];
    const indexLld = currentLlds.findIndex(elem => elem.id === lld.id);
    if (indexLld >= 0) {
      let newLld = { ...lld };
      switch (property) {
        case 'electric_price':
          newLld.is_electric_available = lld.electric_price !== '';
          break;
        case 'mechanical_price':
          newLld.is_mechanical_available = lld.mechanical_price !== '';
          break;
        case 'llt':
          newLld.long_location_type = this.props.llts.content.find(elem =>
            elem.id === lld.long_location_type.id,
          );
          break;
      }
      currentLlds.splice(indexLld, 1, newLld);
      this.setState({ longLocationDurations: currentLlds });
    }
  };

  handleRemoveLongLocationDuration = (lldId) => {
    let currentLlds = [...this.state.longLocationDurations];
    const indexLld = currentLlds.findIndex(elem => elem.id === lldId);
    if (indexLld >= 0) {
      currentLlds.splice(indexLld, 1);
      this.setState({ longLocationDurations: currentLlds });
    }
  };

  render() {
    const {
      renter_id,
      number,
      name,
      email,
      phone,
      latitude,
      longitude,
      radius,
      caution,
      description,
      slots,
      type,
      isOpenAllTime,
      businessHours,
      longLocationDurations,
      isBookable,
      isFreeBooking,
    } = this.state;

    const {
      classes,
      renters,
      pending,
    } = this.props;

    const renderSlots =
      <Grid container style={defaultStyles.media}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography
            align="left"
            variant="h6"
            gutterBottom
          >
            Tarifs de location (en minutes)
          </Typography>
          {slots.map((slot, index) => {
            let time = slots.slice(0, index + 1)
              .map(slot => slot.time).reduce((prev, next) => prev + next);
            let price = slots.slice(0, index + 1)
              .map(slot => slot.price).reduce((prev, next) => prev + next);
            return <SiteSlot
              slot={slot}
              index={index}
              cumulateTime={time}
              cumulatePrice={price}
              onChangePrice={this.onChangeSlotPrice}
              onChangeTime={this.onChangeSlotTime}
              isLast={index + 1 === slots.length}
              onAdd={this.handleAddSlot}
              onRemove={this.handleRemoveSlot}
            />;
          })}
        </Grid>
      </Grid>;

    const renderGeneralInfos =
      <Grid container style={defaultStyles.media}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography
            align="left"
            variant="h6"
            gutterBottom
          >
            Informations Générales
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <TextField
            id="renter_id"
            type="text"
            select
            label="Loueur"
            className={classes.textField}
            value={renter_id}
            onChange={event => this.setState(byPropKey('renter_id', event.target.value))}
            helperText="Choisissez le loueur"
            margin="normal"
            required
          >
            {renters && renters.map(renter => (
              <MenuItem key={renter.id} value={renter.id}>
                {renter.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <SiteTypeSelect type={type} handleChangeType={this.handleChangeType} />
        <Grid item xs={12} sm={12} md={4}>
          <FormControlLabel
            style={{
              marginLeft: 0,
              marginRight: '8px',
              marginTop: '25px',
              marginBottom: 0,
            }}
            control={
              <Checkbox
                checked={isBookable}
                onChange={this.handleChangeIsBookable}
                name="isBookableCheckbox"
                color="primary"
                disabled={type === 5}
              />
            }
            label="Station réservable"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <FormControlLabel
            style={{
              marginLeft: 0,
              marginRight: '8px',
              marginTop: '25px',
              marginBottom: 0,
            }}
            control={
              <Checkbox
                checked={isFreeBooking}
                onChange={this.handleChangeIsFreeBooking}
                name="isFreeBooking"
                color="primary"
                disabled={type === 5}
              />
            }
            label="Location gratuite"
          />
        </Grid>
        <KobooTextField
          label="Numéro"
          id="number"
          onChange={event => this.setState(byPropKey('number', event.target.value))}
          value={number}
        />
        <KobooTextField
          label="Nom"
          id="name"
          onChange={event => this.setState(byPropKey('name', event.target.value))}
          value={name}
          required
        />
        <KobooTextField
          label="Mail"
          id="email"
          onChange={event => this.setState(byPropKey('email', event.target.value))}
          value={email}
        />
        <KobooTextField
          label="Téléphone"
          id="phone"
          onChange={event => this.setState(byPropKey('phone', event.target.value))}
          value={phone}
        />
        <KobooTextField
          label="Latitude"
          id="latitude"
          onChange={event => this.setState(byPropKey('latitude', event.target.value))}
          value={latitude}
          required
        />
        <KobooTextField
          label="Longitude"
          id="longitude"
          onChange={event => this.setState(byPropKey('longitude', event.target.value))}
          value={longitude}
          required
        />
        <KobooTextField
          label="Rayon en mètre"
          id="radius"
          onChange={event => this.setState(byPropKey('radius', event.target.value))}
          value={radius}
          required
        />
        <KobooTextField
          label="Caution en €"
          id="caution"
          onChange={event => this.setState(byPropKey('caution', event.target.value))}
          value={caution}
          required
        />
        <KobooTextField
          label="Description"
          id="description"
          onChange={event => this.setState(byPropKey('description', event.target.value))}
          value={description}
        />
      </Grid>;

    if (pending) {
      return (
        <Loader />
      );
    } else if (renters && renters.length) {
      return (
        <form onSubmit={this.onSubmit} style={defaultStyles.center}>
          {renderGeneralInfos}
          <br />
          {renderSlots}
          <br />
          <SiteBusinessHours
            businessHours={businessHours}
            isOpenAllTime={isOpenAllTime}
            onChangeTime={this.handleChangeTime}
            onSwitch={this.handleSwitch}
            onSwitchIsOpenAllTime={this.handleSwitchIsOpenAllTime}
          />
          <br />
          {type === 5 && <SiteLongLocationDuration
            longLocationTypes={this.props.llts.content || []}
            longLocationDurations={longLocationDurations}
            handleAddLongLocationDuration={this.handleAddLongLocationDuration}
            handleRemoveLongLocationDuration={this.handleRemoveLongLocationDuration}
            handleEditLongLocationDuration={this.handleEditLongLocationDuration}
          />}
          <br />
          <KobooButton disabled={this.props.sending} type="submit">
            {this.props.sending
              ?
              <Spinner
                style={{
                  parent: { margin: '4px auto 0' },
                  child: {},
                }}
              />
              : 'Créer'}
          </KobooButton>
        </form>
      );
    }
    return (
      <Typography variant="subtitle1">
        Aucun loueur n'a été créé, veuillez en créer un <Link to={routes.RENTER_ADD}>ici</Link>.
      </Typography>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    renters: state.renters.content,
    pending: state.renters.pending,
    error: state.renters.error,
    sending: state.sites.sending,
    llts: state.llts,
  };
}

export default compose(
  withAuthorization(authUser => !!authUser),
  withStyles(styles),
  connect(mapStateToProps, {
    postSite,
    getRenters,
    handleError,
    getLongLocationTypes,
  }),
)(AddSiteForm);



// WEBPACK FOOTER //
// ./src/components/Site/AddSiteForm.jsx